<template>
    <div class="c-modal-wrapper">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
            </div>
            <!-- Header Title -->
            <div class="c-modal-info-title"><b>Ko je zakljucao rezervacijue</b></div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body">
        <div class="c-responsive-container">
          <div class="c-p-10 c-ux-color-white">
            Rezervacija je zakljucana od strane korisnika:
            <br/>
            <div v-if="userWhoLockedTable && userWhoLockedTable.tableLocked && userWhoLockedTable.tableLocked.lockedByUserName">
              <b v-if="userWhoLockedTable.tableLocked.lockedByUserName">{{userWhoLockedTable.tableLocked.lockedByUserName}}</b>
              <br/>
              <div>{{returnFormatedDate(userWhoLockedTable.tableLocked.lockedDate)}}</div>
            </div>            
          </div>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-12 c-align-center">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><b>Zatvori</b></button>
            </div>
          </div>
        </div>
      </footer>
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import moment from 'moment'
export default {
  name: 'ModalQuickShowWhoLockedTable',
  props: ['inputModalData'],
  data () {
    return {
      msg: 'ModalQuickShowWhoLockedTable modal',
      resolve: null,
      reject: null,
      // ~ received object of event that we want to show
      userWhoLockedTable: null
    }
  },
  methods: {
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    },
    //
    returnFormatedDate: function (inputDate) {
      var returnValue = '';
      if (inputDate){
        returnValue = moment(inputDate).format('ddd, DD MMM YYYY HH:mm:ss [GMT]');
      }
      //
      return returnValue;
    }
  },
  created () {
    //console.log('~ created- ModalQuickShowWhoLockedTable component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal){
        //console.log('who locked table: ' + JSON.stringify(this.inputModalData.dataForModal, null, 2) );
        this.userWhoLockedTable = this.inputModalData.dataForModal;
      }
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalQuickShowWhoLockedTable component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalQuickShowWhoLockedTable component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/ModalQuickShowWhoLockedTable.vue